import createApiServices from './createApiServices'
import {BACKEND_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: BACKEND_URL})
let api_key = 'b1e813ee2638dcb3b1abd21b4085b0f4d76438ae37bc036225cf26340e945044'
let source = 'ipcc'

export const loginPhone = (payload) => {
    return api.makeRequest({
        url: `/v1.0/base/login?api_key=${api_key}`,
        method: 'POST',
        data: payload
    })
}

export const logoutPhone = (payload) => {
    return api.makeRequest({
        url: `/v1.0/base/logout?api_key=${api_key}`,
        method: 'POST',
        data: payload
    })
}

export const callPhone = (payload) => {
    return api.makeRequest({
        url: `/v1.0/base/makeCall?api_key=${api_key}`,
        method: 'POST',
        data: payload
    })
}

export const phoneCallHistory = (payload) => {
    return api.makeRequest({
        url: `/v1.0/base/searchCall?api_key=${api_key}&source=${source}`,
        method: 'POST',
        data: payload
    })
}

export const phoneHoldCall = (payload) => {
    return api.makeRequest({
        url: `/crm/holdCall`,
        method: 'POST',
        data: payload
    })
}

export const phoneUnHoldCall = (payload) => {
    return api.makeRequest({
        url: `/crm/unholdCall`,
        method: 'POST',
        data: payload
    })
}

export const phoneMuteCall = (payload) => {
    return api.makeRequest({
        url: `/crm/muteCall`,
        method: 'POST',
        data: payload
    })
}

export const phoneUnMuteCall = (payload) => {
    return api.makeRequest({
        url: `/crm/unmuteCall`,
        method: 'POST',
        data: payload
    })
}

export const updateAgentPhone = (payload) => {
    return api.makeRequest({
        url: `v1.0/base/changeAgentStatus?api_key=b1e813ee2638dcb3b1abd21b4085b0f4d76438ae37bc036225cf26340e945044`,
        method: 'POST',
        data: payload
    })
}

export const getAgentStatistics = (payload) => {
    return api.makeRequest({
        url: `/crm/getAgentStatistic`,
        method: 'POST',
        data: payload
    })
}
